import styled from 'styled-components'
import { colors } from '../../../../../constants'

export const PromoItemDom = styled.div`
    height: 145px;
    width: 100%;
    cursor: pointer;
    ${({ alert }) => alert && `background: #FFF1F1;`}
    ${({ disabled }) => disabled && `background: #E6EDF1;`}
`

export const FlexBox = styled.div`
    display: flex;
    flex-wrap: wrap;
`

export const FlexItem = styled.div`
    flex: 40%;
    width: 100%;
`
export const ValueGroup = styled.div`
    height: 60px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${({ withAction }) =>
        withAction &&
        `
      &:hover {
        opacity: 0.6;
      }
    `}
`

export const FooterStyle = {
    background: `${colors.blue}`,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '23px 30px 15px',
    border: 'none',
    position: 'sticky',
    bottom: 0,
}
